<mat-card *transloco="let t; read: 'pageNotFound'" class="root">
  <mat-card-header>
    <mat-card-title>{{ t('noSuchPage') }}</mat-card-title>
    <mat-card-subtitle>{{ t('deletedOrDoesNotExist') }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-actions>
    <a mat-button routerLink="/">{{ t('startWithMain') }}</a>
  </mat-card-actions>
</mat-card>
